import { ApplyFontConfig } from './ApplyFonts.types';

export const EXPLORE_FONTS_CONFIG: ApplyFontConfig[] = [
  { title: 'Merriweather', heading: 'Roboto', paragraph: 'Roboto', titleStyle: { letterSpacing: '-0.03rem' } },
  { title: 'Abril Fatface', heading: 'Poppins', paragraph: 'Lato' },
  { title: 'Playfair Display', heading: 'Alegreya', paragraph: 'Lora', titleStyle: { letterSpacing: '-0.05rem' } },
  { title: 'Montserrat', heading: 'Open Sans', paragraph: 'Source Sans Pro' },
  { title: 'Pattaya', heading: 'PT Serif', paragraph: 'PT Sans' },
  { title: 'Raleway', heading: 'Roboto Condensed', paragraph: 'Muli' },
];

// if there's more than this amount of widgets, we show a loader
export const SHOW_LOADER_WIDGET_COUNT_TRESHOLD = 80;
// check widgets below within this distance - if a text widget has text below its likely a heading
export const BELOW_WIDGET_DISTANCE = 50;

// For determining heading/paragraph
export const HEADING_TRESHOLD = 2;
export const Weight = {
  // More likely that it's a heading
  Bold: 5,
  isAboveLongParagraph: 5,
  HasBeenClassifiedAsHeading: 4,
  LargeFontSize: 4,
  ShortText: 2,
  AboveText: 2,
  H2H6Tag: 1,

  // More likely that it's a paragraph
  SmallFontSize: -5,
  HasBeenClassifiedAsParagraph: -5,
  LongParagraph: -5,
  List: -3,
  EndsInPeriod: -3,
  TinyFontSize: -2,
  LineCount: -3,
  PTag: -1,
};

export const FontSizeTreshold = {
  Large: 20,
  Small: 17,
  Tiny: 12,
};

export const TextCharCountThreshold = {
  Short: 50,
  Long: 150,
};
